import clsx from 'clsx'
import { IconNames } from 'lib/settings/icons'
import Icon from '../Icon/Icon'

export interface StepperProps {
  /**
   * How many steps to show
   */
  steps: number
  /**
   * Which step numbers are completed
   */
  completed?: number[]
  /**
   * Which step number is currently shown in the page
   */
  current: number
}

export default function Stepper({
  steps = 0,
  completed = [],
  current,
}: StepperProps) {
  return (
    <div className="flex justify-center items-center h-10 gap-x-2">
      {Array.from({ length: steps }).map((step, index) => {
        const stepNumber = index + 1
        const isCompleted =
          current !== stepNumber && completed.includes(stepNumber)
        const isCurrent = stepNumber === current
        const icon = isCompleted
          ? 'check-circle-filled'
          : `number-${stepNumber}-circle`
        const colorClassName = isCompleted
          ? 'text-theme-accessibility'
          : isCurrent
            ? 'text-neutral-700'
            : 'text-neutral-600'
        const withDash = steps !== stepNumber
        const dashColorClassName = isCompleted
          ? 'text-theme-accessibility'
          : 'text-neutral-500'

        return (
          <div key={index} className="leading-none flex gap-2 items-center">
            <Icon
              icon={icon as IconNames}
              className={clsx('w-6 h-6', colorClassName)}
            />
            {withDash && (
              <div
                className={clsx(
                  'w-8 h-[2px] rounded-sm bg-current',
                  dashColorClassName,
                )}
              ></div>
            )}
          </div>
        )
      })}
    </div>
  )
}
